import { render, staticRenderFns } from "./BreakCreate.vue?vue&type=template&id=2b7333b8&scoped=true"
import script from "./BreakCreate.vue?vue&type=script&lang=js"
export * from "./BreakCreate.vue?vue&type=script&lang=js"
import style0 from "./BreakCreate.vue?vue&type=style&index=0&id=2b7333b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7333b8",
  null
  
)

export default component.exports